import { useMutation } from '@tanstack/react-query';

import {
  handleResponseSuccess,
  handleResponseThrowError,
} from '@/_utils/services';
import { apiClient } from '@/_config/lib/axios/api-client';

interface SharePlaceFareParams {
  placeId: string;
  placeIds: string[];
}

const postSharePlaceFare = async ({
  placeId,
  placeIds,
}: SharePlaceFareParams) =>
  apiClient
    .post(`/estabelecimentos/${placeId}/fare/share-fare`, {
      placeIds,
    })
    .then(response =>
      handleResponseSuccess(response, 'Tarifa compartilhada com sucesso!')(),
    )
    .catch(
      handleResponseThrowError(
        'Não foi possível compartilhar a tarifa do estabelecimento.',
      ),
    );

export const useSharePlaceFare = () => {
  return useMutation({
    mutationFn: postSharePlaceFare,
  });
};
